<template>
  <in-viewport @inviewport-change="activeChange">
    <video slot="item" ref="videoEl" loop muted :poster='src.poster' playsinline webkit-playsinline>
      <source type="video/mp4" :src='src.mp4'>
      <source type="video/webm" :src='src.webm'>
    </video>
  </in-viewport>
</template>

<style>
  video {
    width: 100%;
  }
</style>

<script>
import { safelyPlayMedia } from '../helpers.js'
import InViewport from '../../Utilities/InViewport.vue'

const src = {
  poster:
    'https://pmd-nrk.akamaized.net/dokumentar/snapstreaks/v2-snap-02122017-telefonen-i-senga.720p.mp4.jpg',
  mp4:
    'https://pmd-nrk.akamaized.net/dokumentar/snapstreaks/v2-snap-02122017-telefonen-i-senga.720p.mp4',
  webm:
    'https://pmd-nrk.akamaized.net/dokumentar/snapstreaks/v2-snap-02122017-telefonen-i-senga.720p.webm'
}

export default {
  data() {
    return {
      src,
      active: false
    }
  },
  created() {
    if (typeof window !== 'undefined' && this.active) {
      requestAnimationFrame(() => this.togglePlayState(this.active ? 'playing' : 'pause'))
    }
  },
  watch: {
    active(active) {
      requestAnimationFrame(() => this.togglePlayState(active ? 'playing' : 'pause'))
    }
  },
  methods: {
    activeChange({ isInViewport }) {
      this.active = isInViewport
    },
    togglePlayState(state) {
      const { videoEl } = this.$refs
      if (state === 'playing' && videoEl.paused) {
        safelyPlayMedia(videoEl).catch(error => console.error({ error }))
      } else if (state === 'pause' && !videoEl.paused) {
        videoEl.pause()
      }
    }
  },
  components: {
    InViewport
  }
}
</script>
